import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const Pagination = ({ currentPage, totalPages, totalRecords, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1 && onPageChange) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages && onPageChange) {
      onPageChange(currentPage + 1);
    }
  };

  const isPreviousDisabled = currentPage <= 1;
  const isNextDisabled = currentPage >= totalPages || totalPages === 0;

  return (
    <div className="flex justify-between items-center mt-3 text-sm">
      <span>Showing {totalRecords} records</span>

      <div className="flex gap-2 items-center">
        <button
          className={`border p-1 rounded ${
            isPreviousDisabled
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
          onClick={handlePrevious}
          disabled={isPreviousDisabled}
          title={isPreviousDisabled ? "First page" : "Previous page"}
        >
          <FiChevronLeft color={isPreviousDisabled ? "#9CA3AF" : "#163D68"} size={20} />
        </button>

        <span>
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          className={`border p-1 rounded ${
            isNextDisabled
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-gray-100 cursor-pointer"
          }`}
          onClick={handleNext}
          disabled={isNextDisabled}
          title={isNextDisabled ? "Last page" : "Next page"}
        >
          <FiChevronRight color={isNextDisabled ? "#9CA3AF" : "#163D68"} size={20} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
